import React from 'react'
import styles from './styles.css'

export default function Loading(props) {
  return <div className={styles.container}>Cargando conversación</div>
}
